(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  const loadYoutubePosters = (root = document) => {
    const posters = root.querySelectorAll('[data-hdt-youtube-poster]:not([src])');

    const loadPoster = (poster) => {
      const videoId = poster.dataset.videoId;
      if (!videoId) return;

      poster.src = ['https://i.ytimg.com/vi', encodeURIComponent(videoId), 'hqdefault.jpg'].join('/');
    };

    if (!('IntersectionObserver' in window)) {
      posters.forEach(loadPoster);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadPoster(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '400px 0px' });

    posters.forEach((poster) => observer.observe(poster));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadYoutubePosters(), { once: true });
  } else {
    loadYoutubePosters();
  }

  document.addEventListener('shopify:section:load', (event) => loadYoutubePosters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-pixar-c1-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-vp-c1-root]').forEach((root) => {
        if (root.dataset.vpC1Initialized === 'true') return;
        root.dataset.vpC1Initialized = 'true';

        const accessoryButtons = [...root.querySelectorAll('[data-vp-accessory]')];
        const accessoryImages = [...root.querySelectorAll('[data-vp-accessory-image]')];

        accessoryButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const key = button.dataset.vpAccessory;
            if (key === 'rack') return;

            const nextState = button.getAttribute('aria-pressed') !== 'true';
            if (key === 'saddle' || key === 'big') {
              accessoryButtons
                .filter((item) => item.dataset.vpAccessory === 'saddle' || item.dataset.vpAccessory === 'big')
                .forEach((item) => {
                  const active = item === button ? nextState : false;
                  item.classList.toggle('is-active', active);
                  item.setAttribute('aria-pressed', String(active));
                  const image = accessoryImages.find((candidate) => candidate.dataset.vpAccessoryImage === item.dataset.vpAccessory);
                  image?.classList.toggle('is-active', active);
                });
              return;
            }

            button.classList.toggle('is-active', nextState);
            button.setAttribute('aria-pressed', String(nextState));
            accessoryImages
              .find((image) => image.dataset.vpAccessoryImage === key)
              ?.classList.toggle('is-active', nextState);
          });
        });

        const loadVideo = (video) => {
          if (video.dataset.vpLoaded === 'true') return;
          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.dataset.vpLoaded = 'true';
          video.preload = 'metadata';
          video.load();
        };

        const videos = [...root.querySelectorAll('[data-vp-autoplay]')];
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if ('IntersectionObserver' in window) {
          const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && video.offsetParent !== null) {
                loadVideo(video);
                if (!reduceMotion) video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          }, { rootMargin: '240px 0px', threshold: 0.05 });
          videos.forEach((video) => videoObserver.observe(video));
        } else {
          videos.forEach((video) => loadVideo(video));
        }

        root.querySelectorAll('[data-vp-scroll-prev], [data-vp-scroll-next]').forEach((button) => {
          button.addEventListener('click', () => {
            const section = button.closest('section');
            const track = section?.querySelector('[data-vp-scroll-track]');
            if (!track) return;
            const direction = button.hasAttribute('data-vp-scroll-prev') ? -1 : 1;
            track.scrollBy({ left: direction * track.clientWidth * 0.86, behavior: reduceMotion ? 'auto' : 'smooth' });
          });
        });

        root.querySelectorAll('[data-vp-scroll-track]').forEach((track) => {
          const dotsHost = track.nextElementSibling;
          if (!dotsHost?.matches('[data-vp-slider-dots]')) return;

          const items = [...track.children];
          const dots = items.map((_, index) => {
            const dot = document.createElement('span');
            dot.className = `vp-c1__slider-dot${index === 0 ? ' is-active' : ''}`;
            dotsHost.append(dot);
            return dot;
          });

          let frame;
          const updateDots = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
              const center = track.scrollLeft + track.clientWidth / 2;
              let activeIndex = 0;
              let activeDistance = Number.POSITIVE_INFINITY;
              items.forEach((item, index) => {
                const itemCenter = item.offsetLeft + item.offsetWidth / 2;
                const distance = Math.abs(center - itemCenter);
                if (distance < activeDistance) {
                  activeDistance = distance;
                  activeIndex = index;
                }
              });
              dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
            });
          };

          track.addEventListener('scroll', updateDots, { passive: true });
          window.addEventListener('resize', updateDots, { passive: true });
          updateDots();
        });

        root.querySelectorAll('[data-vp-carousel-progress]').forEach((progress) => {
          const track = progress.closest('section')?.querySelector('[data-vp-scroll-track]');
          const thumb = progress.querySelector('[data-vp-carousel-thumb]');
          if (!track || !thumb) return;

          let frame;
          const updateProgress = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
              const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
              const visibleRatio = Math.min(1, track.clientWidth / Math.max(track.scrollWidth, 1));
              const travel = progress.clientWidth * (1 - visibleRatio);
              const position = maxScroll > 0 ? (track.scrollLeft / maxScroll) * travel : 0;
              thumb.style.width = `${visibleRatio * 100}%`;
              thumb.style.transform = `translateX(${position}px)`;
            });
          };

          const seek = (event) => {
            const bounds = progress.getBoundingClientRect();
            const ratio = Math.max(0, Math.min(1, (event.clientX - bounds.left) / Math.max(bounds.width, 1)));
            track.scrollLeft = ratio * Math.max(0, track.scrollWidth - track.clientWidth);
          };

          let dragging = false;
          progress.addEventListener('pointerdown', (event) => {
            dragging = true;
            progress.setPointerCapture(event.pointerId);
            seek(event);
          });
          progress.addEventListener('pointermove', (event) => {
            if (dragging) seek(event);
          });
          progress.addEventListener('pointerup', (event) => {
            dragging = false;
            progress.releasePointerCapture(event.pointerId);
          });
          progress.addEventListener('pointercancel', () => { dragging = false; });
          track.addEventListener('scroll', updateProgress, { passive: true });
          window.addEventListener('resize', updateProgress, { passive: true });
          updateProgress();
        });

        const videoModal = root.querySelector('[data-vp-video-modal]');
        const videoModalSlot = videoModal?.querySelector('[data-vp-video-modal-slot]');
        let previousBodyOverflow = '';
        let lastVideoTrigger;

        const closeVideoModal = () => {
          if (!videoModal || videoModal.hidden) return;
          videoModal.hidden = true;
          videoModalSlot?.replaceChildren();
          document.body.style.overflow = previousBodyOverflow;
          lastVideoTrigger?.focus();
        };

        videoModal?.querySelectorAll('[data-vp-modal-close]').forEach((button) => {
          button.addEventListener('click', closeVideoModal);
        });

        videoModal?.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeVideoModal();
        });

        root.querySelectorAll('[data-vp-youtube-modal]').forEach((button) => {
          button.addEventListener('click', () => {
            const videoId = button.dataset.vpYoutubeModal;
            if (!videoId || !videoModal || !videoModalSlot) return;
            const iframe = document.createElement('iframe');
            iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&playsinline=1&rel=0&modestbranding=1`;
            iframe.title = button.getAttribute('aria-label') || 'Video';
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.allowFullscreen = true;
            videoModalSlot.replaceChildren(iframe);
            lastVideoTrigger = button;
            previousBodyOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            videoModal.hidden = false;
            videoModal.querySelector('[data-vp-modal-close]:not(.vp-c1__video-modal-backdrop)')?.focus();
          });
        });

        root.querySelectorAll('[data-vp-youtube]').forEach((button) => {
          button.addEventListener('click', () => {
            const videoId = button.dataset.vpYoutube;
            if (!videoId) return;
            const iframe = document.createElement('iframe');
            iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&playsinline=1&rel=0&modestbranding=1`;
            iframe.title = button.getAttribute('aria-label') || 'Video';
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.allowFullscreen = true;
            iframe.loading = 'lazy';
            button.replaceWith(iframe);
          }, { once: true });
        });

        const specificationTabs = [...root.querySelectorAll('[data-vp-tab]')];
        const specificationPanels = [...root.querySelectorAll('[data-vp-panel]')];
        specificationTabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const key = tab.dataset.vpTab;
            specificationTabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
            specificationPanels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.vpPanel === key));
          });
        });

        const geometryTabs = [...root.querySelectorAll('[data-vp-geometry-tab]')];
        const geometryPanels = [...root.querySelectorAll('[data-vp-geometry-panel]')];
        geometryTabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const key = tab.dataset.vpGeometryTab;
            geometryTabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
            geometryPanels.forEach((panel) => {
              const active = panel.dataset.vpGeometryPanel === key;
              panel.classList.toggle('is-active', active);
              panel.hidden = !active;
            });
          });
        });

        const faqItems = [...root.querySelectorAll('.vp-c1__faq-list details')];
        faqItems.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            faqItems.filter((candidate) => candidate !== item).forEach((candidate) => {
              candidate.open = false;
            });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
